module.exports = __webpack_public_path__ + "img/slika30.23c86ffd.jpg";